export default __webpack_public_path__ + "static/media/back_circle.d9ad9199.svg";